// export const API_URL = "https://meat-market.onrender.com";
export const API_URL = "https://api.meatmarket.live";

// export const API_URL = "http://localhost:3001";

